export default __webpack_public_path__ + "static/mugshot-5073b9c22e9e14bb3bc55bd39ea6fd87.jpg";